import React, {
  lazy,
  Suspense,
  FunctionComponent,
  useRef,
  useCallback,
} from 'react';
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { CreateMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';
import { usePopover } from '../popover';

const HeaderCreateMenuPopoverPromise = import(
  /* webpackChunkName: "create-menu-popover" */ 'app/gamma/src/components/popovers/header-create-menu'
);
const HeaderCreateMenuPopover = lazy(() => HeaderCreateMenuPopoverPromise);

export const CreateMenuButton: FunctionComponent = () => {
  const createMenuButtonRef = useRef<HTMLButtonElement>(null);
  const { isPopoverShown, showPopover } = usePopover({
    name: CreateMenuPopoverId,
  });
  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ADD_MENU,
      method: 'by clicking header add menu button',
    });
    showPopover();
  }, [showPopover]);

  return (
    <>
      <HeaderButton
        icon={IconName.Add}
        onClick={onClick}
        ref={createMenuButtonRef}
        testId={HeaderTestIds.CreateMenuButton}
      />
      {isPopoverShown && (
        <Suspense fallback={null}>
          <HeaderCreateMenuPopover target={() => createMenuButtonRef.current} />
        </Suspense>
      )}
    </>
  );
};
